<div class="flex h-screen">
  <app-wg-sidebar (sidebarClicked)="sidebarChanged($event)"></app-wg-sidebar>
  <div class="flex-1 flex flex-col min-w-0">
    <app-wg-header></app-wg-header>
    <div class="flex-1 overflow-auto" cdkScrollable>

<div class="content">

  <div class="inner">

    <div class="inner-item-wrapper">
      <div class="item-container">
        <h1>{{translationService.translate('galis_js_dashboard_search')}}</h1>
        <div class="search-control">
          <div class="wrapper">
            <input [(ngModel)]="searchTerm" type="text" (keydown.enter)="dashboardSearch($event)" placeholder="{{translationService.translate('galis_js_dashboard_whatareyoulookingfor')}}" />
            <div class="search-selector">
              <div class="dd-search dash" (click)="goToSearch()">
                <p>{{translationService.translate('WebGalis_Module_PPMSCIS_Search')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="containers">
      <div class="container-wrapper">
        <div class="container sided">
          <div class="container-holder container-one">
            <h1>{{translationService.translate('galis_js_dashboard_quickactions')}}</h1>

            <a (click)="navigate('cms/ppmscis/offenderprofile')">
              <div class="box">
                <img src="Content/css/Images/ikona-new-form@3x.png" />
                <p>{{translationService.translate('galis_js_dashboard_controled_subjects')}}</p>
              </div>
            </a><!--
            --><a (click)="navigate('cms/probation/courtjudgementinformation')">
            <div class="box">
              <img src="Content/css/Images/ikona-new-form@3x.png" />
              <p>{{translationService.translate('galis_js_dashboard_cji')}}</p>
            </div>
          </a><!--
          --><a (click)="navigate('cms/penaltydata')">
          <div class="box">
            <img src="Content/css/Images/ikona-new-form@3x.png" />
            <p>{{translationService.translate('galis_js_dashboard_penaltyData')}}</p>
          </div>
        </a><!--
        --><a (click)="navigate('cms/probation/visitationprotocol')">
        <div class="box">
          <img src="Content/css/Images/ikona-new-form@3x.png" />
          <p>{{translationService.translate('galis_js_dashboard_visitaionProtocol')}}</p>
        </div>
      </a><!--
      --><a (click)="navigate('cms/probation/offendertransfer')">
      <div class="box">
        <img src="Content/css/Images/ikona-new-form@3x.png" />
        <p>{{translationService.translate('galis_js_dashboard_transfer1')}}</p>
      </div>
    </a><!--
    --><a (click)="navigate('cms/probation/offendertransfer')">
    <div class="box">
      <img src="Content/css/Images/ikona-new-form@3x.png" />
      <p>{{translationService.translate('galis_js_dashboard_transfer2')}}</p>
    </div>
  </a><!--
  --><a (click)="navigate('cms/probation/offendertransfer')">
  <div class="box">
    <img src="Content/css/Images/ikona-new-form@3x.png" />
    <p>{{translationService.translate('galis_js_dashboard_transfer3')}}</p>
  </div>
</a><!--
--><a (click)="navigate('cms/probation/offendertransfer')">
<div class="box">
  <img src="Content/css/Images/ikona-new-form@3x.png" />
  <p>{{translationService.translate('galis_js_dashboard_transfer4')}}</p>
</div>
</a>


</div>
</div>
<div class="container">
  <div class="container-holder">
    <!-- <div class="extend-menu"></div> -->
    <h1 class="last-edited">{{translationService.translate('galis_js_dashboard_lasteditdata')}}</h1>

    <div class="side">
      <div class="box" style="cursor:initial;" (click)="navigate('cms/ppmscis/list?model=Eurodesign.MoJ.PPMSCIS.Application.Model.Module.Penitentiary.CourtJudgementInformationModel&url=cms/probation/courtjudgementinformation&view=1')">
        <img src="Content/css/Images/ikona-new-workflow@3x.png" />
        <p>{{translationService.translate('galis_js_dashboard_controled_subjects')}}</p>
      </div>
      <div class="info">
        <p class="headline">
          @for (offenderProfile of offenderProfiles; track offenderProfile) {
            <span class="headline-span">
                                          <a (click)="navigateToDetails('cms/probation/courtjudgementinformation?id=',offenderProfile)">{{offenderProfile.Title}}</a>
                                        </span>
}
                                    </p>                                  
                                </div>
                            </div>
                            <!--<div class="side">
                              <div class="box" style="cursor:initial;">
                                    <img src="Content/css/Images/ikona-new-form@3x.png" />
                                    <p>{{translationService.translate('galis_js_dashboard_cji')}}</p>
                                </div>
                                <div class="info">
                                    <p class="headline">
                                      <span *ngFor="let cji of courtJudgements" class="headline-span">
                                          <a (click)="navigateToDetails('cms/probation/courtjudgementinformation?id=',cji)">{{cji.Title}}</a>
                                      </span>
                                    </p> 
                                </div>
                            </div>-->
                            <div class="side">
                              <div class="box" style="cursor:initial;">
                                    <img src="Content/css/Images/ikona-new-report@3x.png" />
                                    <p>{{translationService.translate('galis_js_dashboard_transfersupcoming')}}</p>
                                </div>
                                <div class="info">
                                    <p class="headline">
                                      @for (upcomingTransfer of upcomingTransfers; track upcomingTransfer) {
<span class="headline-span">
                                          <a (click)="navigateToDetails('cms/probation/offendertransfer?id=',upcomingTransfer)">{{upcomingTransfer.Title}}</a>
                                      </span>
}                                      
                                    </p> 
                                </div>
                            </div>
    
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    </div>

    <div class="dc-dashboard-card-section">
      <sem-daily-challenge></sem-daily-challenge>
    </div>

    </div><!-- .flex-1.overflow-auto -->
  </div><!-- .flex-1.flex.flex-col -->
</div><!-- .flex.h-screen -->
